import React, { useEffect, useRef } from 'react'
import { connect } from 'react-redux'
import { getCasesRecives } from '../../store/actions'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import { InputTextAreaComponent } from 'recupero-comunes'
import Select from '../../utils/select'

const FormGestionCases = ({ data, onGetGestionCasesReceive, form }) => {
  useEffect(() => {
    onGetGestionCasesReceive({
      concepto: '200'
    })
  }, [])

  const datas = data.filter((receive) => receive.agrupacion === 1)

  const selects = ['datas']
  const refs = useRef(selects.map(() => React.createRef()))

  return (
    <div>
      <Row>
        <Col md='5'>
          <Select
            ref={refs.current[selects.indexOf('datas')]}
            name='estadoCaso'
            label={form?.formLabel['gestcasos-cmb-recepcionar']}
            labelKey='nombre'
            options={datas}
          />
        </Col>
        <Col md='7'>
          <InputTextAreaComponent
            name='observacion'
            type='text'
            label={form?.formLabel['gestcasos-text-observacion']}
          />
        </Col>
      </Row>
    </div>
  )
}
const mapStateToProps = (state) => ({
  data: state.cases.receives
})

const mapDispatchToProps = (dispatch) => ({
  onGetGestionCasesReceive: (query) => dispatch(getCasesRecives(query))
})

export default connect(mapStateToProps, mapDispatchToProps)(FormGestionCases)
